export const baseRules = {
  createDepartmentName: { required: true, message: '请选择创建组织' },
  // saleDepartmentName: { required: true, message: '请选择销售组织' },
  bidTitle: { required: true, message: '请选择投标抬头' },
  bidderId: { required: true, message: '请选择投标人员' },
  bidderName: { required: true, message: '请选择投标人员' },
  applyDate: { required: true, message: '请输入立项申请日期' },
  projectName: { required: true, message: '项目名称' },
  projectSourceType: { required: true, message: '请选择项目来源' },
  bidOpeningDate: { required: true, message: '请选择开标日期' },
  bidClosingDate: { required: true, message: '请选择截标日期' },
  bidTotalAmount: [{ required: true, message: '请输入投标总金额' }],
  productType: { required: true, message: '请选择产品类型', trigger: 'change' },
  serviceTypeCode: { required: true, message: '请选择服务类型', trigger: 'change' },
  projectStartDate: { required: true, message: '请选择项目开始日期' },
  projectBusinessTypeNo: { required: true, message: '请选择项项目业务类型' },
  platformCompanyName: { required: true, message: '请选择平台公司' },
  estimatedProfit: { required: true, message: '必填字段' },
  isBidBusiness: { required: true, message: '必填字段' },
  collectionDays: { required: true, message: '必填字段' },
  businessCycle: { required: true, message: '必填字段' },
  linkedCompanyCode: { required: true, message: '必填字段', trigger: 'change' },
  projectSort: { required: true, message: '必填字段', trigger: ['change', 'blur'] },
};
